var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2325 4.20143C10.9837 2.78247 13.0164 2.78246 13.7676 4.20143L21.1067 18.0642C21.8119 19.3962 20.8463 20.9999 19.3391 20.9999H4.66095C3.1538 20.9999 2.18819 19.3962 2.89337 18.0642L10.2325 4.20143ZM19.3391 18.9999L12 5.13721L4.66094 18.9999L19.3391 18.9999Z",
    fill: "#FFD525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.99994C11 9.44766 11.4478 8.99994 12 8.99994C12.5523 8.99994 13 9.44766 13 9.99994V13.9999C13 14.5522 12.5523 14.9999 12 14.9999C11.4478 14.9999 11 14.5522 11 13.9999V9.99994Z",
    fill: "#FFD525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.9999C13 17.5522 12.5523 17.9999 12 17.9999C11.4478 17.9999 11 17.5522 11 16.9999C11 16.4477 11.4478 15.9999 12 15.9999C12.5523 15.9999 13 16.4477 13 16.9999Z",
    fill: "#FFD525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningButton);
export default __webpack_public_path__ + "static/media/WarningButton.3f2e8440fd8451a6996cf88ca0a365c6.svg";
export { ForwardRef as ReactComponent };